export default __webpack_public_path__ + "media/images/gmap_marker_active-fd158837b87d4d7f9353c6079c152921.png";